import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
//import KnowledgeBase from '../KnowledgeBase/yggdrasil';
import KnowledgeBase from '../KnowledgeBase';


const kB = ({match}) => {
    return (
        <>
            <Switch>
                <Route path={`${match.path}/scans`} component={KnowledgeBase} />
                <Route path={`${match.path}`} component={KnowledgeBase} />
            </Switch>
        </>
    )
}

export default kB;